import { Role } from './role';
import { User } from './user';
import { UserModel } from './user.model';
import { Organization } from './organization';
import { ValidationError } from './validation.error';

export type PermissionScope = 'MY_GROUP' | 'GROUPS_UNDER';

export const PermissionScopes = {
  MY_GROUP: 'MY_GROUP' as PermissionScope,
  GROUPS_UNDER: 'GROUPS_UNDER' as PermissionScope
};

export interface Permission {
  code: string; // permission code
  role: Role;
  group: User;
  softwareSystem: User;
  permissionScope?: PermissionScope;
  scopeGroup?: User;
  appliesTo?(group: number | Organization): boolean;
}

export class PermissionModel implements Permission {
  code: string; // permission code
  role: Role;
  group: User;
  softwareSystem: User;
  permissionScope = PermissionScopes.MY_GROUP;
  scopeGroup?: User;

  static create(props: Partial<Permission>): Permission {
    if (!props || !props.code || !props.group || !props.role) {
      throw new ValidationError('Permission is missing type, role and/or group');
    }

    return new PermissionModel(props as Permission);
  }

  constructor(props: Permission) {
    this.code = props.code || '';
    this.role = { ...props.role };
    this.group = UserModel.create(props.group) as User;
    this.softwareSystem = UserModel.create(props.softwareSystem) as User;
    this.permissionScope = props.permissionScope && props.permissionScope in PermissionScopes ?
      props.permissionScope :
      PermissionScopes.MY_GROUP;
    this.scopeGroup = UserModel.create(props.scopeGroup as User) as User;
  }

  appliesTo(groupOrIdOrCode: string | number | Organization): boolean {
    return this.group.id === (groupOrIdOrCode as number) ||
      this.group.code === (groupOrIdOrCode as string) ||
      (
        typeof groupOrIdOrCode === 'object' &&
        this.group.id === groupOrIdOrCode.id
      ) || (
        this.scopeGroup != null &&
        this.scopeGroup.isUnder != null &&
        this.scopeGroup.isUnder(groupOrIdOrCode)
      );
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/permission.ts